import {fetchWrapper} from 'services/restApi';

export const importQuestions = (questions) => {
  return fetchWrapper('POST', '/api/admin/importer/', {questions});
};
